export default "__VITE_ASSET__Oti79fQb__"